export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10874.87bdb0f2.jpg";